import { Component, Vue } from 'vue-property-decorator';
import { request } from '@/tools/request';
import LogoBar from '@/components/LogoBar/LogoBar'

@Component<Contact>({
  components: {
    LogoBar,
  },
})
export default class Contact extends Vue {
  protected isScrolled: boolean = false;
  protected contactName: string = '';
  protected contactEmail: string = '';
  protected contactMessage: string = '';
  protected mailSend: boolean = false;

  public mounted() {
    //
  }

  public created() {
    window.addEventListener('scroll', this.checkScroll);
  }

  public destroyed() {
    window.removeEventListener('scroll', this.checkScroll);
  }

  protected sendContactMail() {

    const payload: any = {
      userName: this.contactName,
      userEmail: this.contactEmail,
      userMessage: this.contactMessage,
    };

    request('post', 'https://us-central1-api-solution.cloudfunctions.net/webApi/api/v1/sendMail', payload).then(
      (response: object) => {
        console.log('request response', response);
        this.mailSend = true;
      },
      (error: any) => {
        console.log('request error', error);
      }
    );
  }

  protected checkScroll() {
    const scrollObject = {
      y: window.pageYOffset
    }
    
    if (scrollObject.y > 30) this.isScrolled = true;
    if (scrollObject.y < 30) this.isScrolled = false;
  }

}
